export const pressureWoundTypes = [
  "pressureUlcer",
  "pressureKennedy",
  "pressureDeviceRelated"
];
